import { render, staticRenderFns } from "./StagingSectionEditorHeader.vue?vue&type=template&id=4be257a3"
import script from "./StagingSectionEditorHeader.vue?vue&type=script&lang=ts"
export * from "./StagingSectionEditorHeader.vue?vue&type=script&lang=ts"
import style0 from "./StagingSectionEditorHeader.vue?vue&type=style&index=0&id=4be257a3&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports